import { DomrfCalculator, IProgram, IProps as IDomrfCalculatorProps } from '@cian/frontend-domrf-calculator';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionNew } from 'shared/components/CardSectionNew';
import { selectOfferCategory, selectOfferId } from 'shared/selectors';
import { regionIdSelector } from 'shared/selectors/offerData/geo/regionIdSelector';

import { useApplicationContext } from '../ApplicationContext';
import { MortgageCalculatorContainer } from '../MortgageCalculator';

type TTextData = Pick<
  IDomrfCalculatorProps,
  'title' | 'subtitle' | 'priceTooltipTitle' | 'priceTooltipText' | 'escrowTooltipText' | 'escrowTooltipTitle'
>;

export const SuburbanCalculatorContainer = () => {
  const { config } = useApplicationContext();
  const regionId = useSelector(regionIdSelector);
  const offerId = useSelector(selectOfferId);
  const category = useSelector(selectOfferCategory);

  const domrfPrograms = config.get<IProgram[]>('audience.domrfMortgage.programs');
  const textData = config.get<TTextData>('audience.domrfMortgage.textData') || undefined;

  if (!domrfPrograms || category !== 'landSale') {
    return <MortgageCalculatorContainer />;
  }

  return (
    <CardSectionNew>
      <DomrfCalculator
        programs={domrfPrograms}
        regionId={regionId}
        startPrice={7000000}
        pageType="card"
        objectId={offerId}
        {...textData}
      />
    </CardSectionNew>
  );
};
